<template>
  <draggable
    handle=".handle"
    @change="change" :list="value" class="dragArea" tag="ul" :group="{ name: 'g1' }"
  >
    <li v-for="el in value" :key="el.id" class="li li-handle">
      <div class="list-container">
        <div class="list-name handle">
          <i class="fa fa-align-justify"></i>
          <span>{{ el.name }}</span>
          <i class="fa fa-edit" @click="editObject = el"></i>

        </div>
        <div class="controls">
          <AddObject :parentId="el.id" @update="$emit('update')">
            <span>+</span>
          </AddObject>
          <span class="delete" @click="deleteObject(el.id)">-</span>
          <router-link
            :to="`/dashboard/jobs/${el.id}?obj=${el.id}${$route.query.plan ? '&plan=' + $route.query.plan + '&name=' + $route.query.name: ''}${$route.query.version ? '&version=' + $route.query.version + '&name=' + $route.query.name: ''}`">
            <img src="@/assets/settings.svg"/>
          </router-link>
        </div>
      </div>
      <nested-draggable @update="$emit('update')" @input="change" :value="el.objects" :parentId="el.id"/>
    </li>

    <el-dialog
      title="Редактирование объекта"
      :visible.sync="editObject"
      width="30%"
      :before-close="handleClose"
    >
      <el-form>
        <el-form-item label="Название объекта">
          <el-input
            @input="change(value)"
            v-model="editObject && editObject.name" placeholder="Название объекта"
          />
        </el-form-item>

        <el-form-item label="Код объекта">
          <el-input
            @input="change(value)"
            v-model="editObject && editObject.code"
          />
        </el-form-item>

        <router-link :to="`/dashboard/obj/${editObject && editObject.id}/inputs-show`">
          <el-button style="width: 100%">Настройка полей</el-button>
        </router-link>
        <el-checkbox
          @change="changeAnalytics(editObject)"
          :value="!(editObject && editObject.ignoreAnalytics)" style="margin-top: 10px">Показывать в аналитике
        </el-checkbox>

      </el-form>
    </el-dialog>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable';
import AddObject from '@/views/Dashboard/Objects/components/AddObject';
import firebase from 'firebase';
import {array_move} from '../../../../utils/getChild';

export default {
  props: {
    value: {
      type: Array,
    },
    parentId: String,
    isMain: Boolean,
  },
  components: {
    AddObject,
    draggable,
  },
  data() {
    return {
      editObject: null,
    };
  },
  methods: {
    fire() {
      if (this.$route.query.plan) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan)
      }

      if (this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    changeAnalytics(value) {
      let _value = [...this.value];
      const index = this.value.findIndex((v) => v.id === value.id);

      _value[index].ignoreAnalytics = !value.ignoreAnalytics;

      this.$emit('input', _value);
    },
    handleClose() {
      this.editObject = null;
    },
    input(value) {
      this.$emit('input', value);
    },
    change(value) {
      let _value = [...this.value];

      if (value.added) {
        value.added.element.parentId = this.parentId;
        _value[value.added.newIndex] = value.added.element;
      }

      this.$emit('input', _value);
    },
    update() {
      this.$emit('update');
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить этот объект? Все работы, связанные с этим объектом будут удалены.', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {

        this.fire()
          .collection('objects')
          .doc(id).delete()
          .then(async () => {


            const objectskills =
              await this.fire()
                .collection('objects')
                .where(`parentId`, '==', id)
                .get();

            const jobs_ids = [];

            objectskills.forEach((object) => {
              jobs_ids.push(object.id)
            })


            const jobskills =
              await this.fire()
                .collection('jobs')
                .where(`objects`, 'array-contains-any', [id, ...jobs_ids])
                .get();

            const batch = firebase.firestore().batch();

            objectskills.forEach(doc => {
              batch.delete(doc.ref);
            });

            jobskills.forEach(doc => {
              batch.delete(doc.ref);
            });

            await batch.commit();

            this.$emit('update');
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Объект удален',
              type: 'success',
            });
          });
      });
    },
  },

  name: 'nested-draggable',
};
</script>
<style scoped lang="scss">
.dragArea {
  min-height: 20px;
  padding: 10px 0 0 0;
  margin-left: 14px;
}

.list-container {
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
  background: #f7f7f7;
  border-radius: 4px;
  min-height: 50px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  padding: 0 10px;
  cursor: pointer;
}

.controls {
  display: flex;
  justify-content: space-between;
  width: 140px;
  font-size: 22px;
  font-weight: 400;

  .delete {
    font-size: 36px;
    font-weight: 100;
    color: #c0392b;
  }
}

.list-name {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.drag-handle {
  background: #eee;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 40px;
  margin-left: -10px;
}

.handle {
  i {
    margin-right: 10px;
  }
}

.controls-arrow {
  margin-right: 10px;
  display: flex;
  align-items: center;

  i {
    font-size: 16px;
    margin-right: 10px;
  }
}

.fa-edit {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Objects/components/List.vue